import { useState, useCallback, useRef, useLayoutEffect } from 'react';
import { useUser } from '../context/UserContext';

export function draftKey(userId, target) { return userId && target ? `polka_draft_${userId}_${target}` : null; }
export function readDraft(key) {
  try {
    const entry = key && JSON.parse(localStorage.getItem(key) || 'null');
    return entry && Date.now() - entry.at < 7 * 86400000 && entry.at <= Date.now() ? entry.text : '';
  } catch { return ''; }
}
export default function useDraft(target) {
  const { user } = useUser(), key = draftKey(user?.id, target);
  const [state, setState] = useState(() => ({ key, value: readDraft(key), saved: true }));
  const text = state.key === key ? state.value : readDraft(key);
  const current = useRef({ key, value: text });
  useLayoutEffect(() => { current.current = { key, value: text }; }, [key, text]);
  const setText = useCallback(next => {
    const previous = current.current.key === key ? current.current.value : readDraft(key);
    const value = (typeof next === 'function' ? next(previous) : next).slice(0, 20000);
    let saved = false;
    try {
      if (key) { if (value) localStorage.setItem(key, JSON.stringify({ at: Date.now(), text: value })); else localStorage.removeItem(key); saved = true; }
    } catch { /* The text stays editable in memory if storage is full. */ }
    if (current.current.key === key) { current.current.value = value; setState({ key, value, saved }); }
  }, [key]);
  return [text, setText, !!text && (state.key === key ? state.saved : true)];
}
